import { useCallback } from 'react';
import type { Mode } from '../../../../types';
import type { ButtonDirection } from '../DateNavigator';
import { Translation } from './Translation';

export const useGetTooltipTitle = () =>
  useCallback(({ date, direction, mode }: { date: Date; direction: ButtonDirection; mode: Mode }) => {
    if (direction === 'today') {
      switch (mode) {
        case 'day':
          return <Translation date={date} direction="today" i18nKey="Go to today's date" mode="day" />;
        case 'month':
          return <Translation date={date} direction="today" i18nKey="Go to current month" mode="month" />;
        case 'week':
          return <Translation date={date} direction="today" i18nKey="Go to current week" mode="week" />;
      }
    }

    switch (mode) {
      case 'day':
        return direction === 'next' ? (
          <Translation date={date} direction="next" i18nKey="Go to following day" mode={mode} />
        ) : (
          <Translation date={date} direction="previous" i18nKey="Go to previous day" mode={mode} />
        );
      case 'month':
        return direction === 'next' ? (
          <Translation date={date} direction="next" i18nKey="Go to following month" mode={mode} />
        ) : (
          <Translation date={date} direction="previous" i18nKey="Go to previous month" mode={mode} />
        );
      case 'week':
        return direction === 'next' ? (
          <Translation date={date} direction="next" i18nKey="Go to following week" mode={mode} />
        ) : (
          <Translation date={date} direction="previous" i18nKey="Go to previous week" mode={mode} />
        );
    }
  }, []);
